import React, { useState, useEffect } from "react";
import "../../scss/Dashboard.css";
import Navbar from "../../components/Navbar";
import { Tab, Tabs, TabList } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useDispatch, useSelector } from "react-redux";
import eye from "../../assets/eye_159078.png";
import { toast } from "react-toastify";

import { ExportToExcelGeneric } from "../../Utils/GenerateExcel";

import { allDataThunk, allData } from "../../redux/allDataSlice";
import { genericReport } from "../../Utils/reportGenerator";

const reportSuffix=" allergies";

const AllergyReport = () => {
  const dispatch = useDispatch();
  const [selectedCeremonies, setSelectedCeremonies] = useState([]);
  const [guestList, setGuestList] = useState([]);
  const [reportName, setReportName] = useState("All");
  const [guestListLoading, setGuestListLoading] = useState(true);
  const allDataLoaded = useSelector((state) => state.allData.loaded);
  const allDataChanged = useSelector((state) => state.allData.changed);

  const exportData = () => {
    const data = [["Name", "Guest of", "Email", "Mobile", "Group", "Allergies"]];
    for (const guest of guestList) {
      data.push([
        guest?.guest_name,
        guest?.parentGuest?.guest_name,
        guest?.email,
        guest?.mobile_number,
        guest?.group_name,
        guest?.allergy_combined,
      ]);
    }
    return data;
  }

const getAllergyReport=() => {
  const result = genericReport(allData, ["allergy"]);
  for (const rec of result) {
    const newArray = asArray(rec.allergy).concat(asArray(rec.allergy_details));
    rec.allergy_combined = newArray.join(", ");
  }
  return result;
}

  const handleTabClick = async (ceremonyName) => {
    try {
      const result = getAllergyReport();
      if (ceremonyName==="") {
        setGuestList(result);
        setReportName("All");
      } else{
        const filteredResult = result.filter(d=>d.attendance.indexOf(ceremonyName)>=0);
        setGuestList(filteredResult);
        setReportName(ceremonyName);
      }
    } catch (e) {
      console.log("handleTabClick", e);
      toast.error("failed");
    }
  };
  useEffect(() => {
    dispatch(allDataThunk());
  }, []);

  useEffect(()=>{
    if (!allDataLoaded) {
      return;
    }

    const selectedCeremonyNames = allData.ceremonies.map((item) => ({
      name: item.ceremony_name,
      id: item.id,
      icon: item.icon_link,
    }));
    setSelectedCeremonies(selectedCeremonyNames);

    const result = getAllergyReport();
    console.log("ALLERGYREPORT", result);
    setGuestList(result);
    setGuestListLoading(false);
  }, [allDataChanged]);

  const asArray = (a) => {
    if (Array.isArray(a)) return a;
    if (a===undefined || a===null) return [];
    return [a];
  }

  return (
    <div>
      <Navbar />
      <div class="container mid-title card-b-1">
        <div class="mid-title-left">Allergy Reports</div>
        <div class="crl"></div>
        <div class="row">
          <div class="col-sm-12 r-text">
          Welcome to your reporting page. Here you will find a selection of reports that you can view and download into excel to help you work with your suppliers as well as plan and budget for every one of your events.
          </div>
        </div>
      </div>
      <div class="main-container">
        <div class="container bg-w">

          <div className="row gust-box">
            <div class="col-sm-12">
              <ExportToExcelGeneric dataFn={exportData} fileName={reportName + reportSuffix} />
            </div>
            <div className="col-12">
              <div className="tabs-home">
                <Tabs>
                  <TabList>
                    <Tab>
                      <div className="" onClick={() => handleTabClick("")} >
                        <span>All ceremonies</span>
                      </div>
                    </Tab>

                    {selectedCeremonies?.map((item) => (
                      <Tab>
                        <div className="" onClick={() => handleTabClick(item.name)} >
                          <span>{item.name}</span>
                        </div>
                      </Tab>
                    ))}
                  </TabList>

                  <div className="gray-box mt-3  menu-tabing">
                    <div className="gray-box-inv">
                      {reportName + reportSuffix}{" "}
                      <div className="sky-circle d-inline-block">
                        {guestList?.length}
                      </div>
                    </div>

                    <TabList>
                      {guestListLoading ? (
                        <h5>Loading...</h5>
                      ) : guestList?.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Guest of</th>
                                <th>Email</th>
                                <th>Mobile Number</th>
                                <th>Group</th>
                                <th>Allergies</th>
                                <th>RSVP</th>
                              </tr>
                            </thead>
                            <tbody>
                              {guestList?.map((guest, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{guest?.guest_name}</td>
                                    <td>{guest?.parentGuest?.guest_name}</td>
                                    <td>{guest?.email}</td>
                                    <td>{guest?.mobile_number}</td>
                                    <td>{guest?.group_name}</td>
                                    <td>{guest?.allergy_combined}</td>

                                    <td className="text-center">
                                    {(guest?.rsvp_code || guest?.parentGuest?.rsvp_code) && 
                                      <a href={"/rsvp/code/"+(guest.rsvp_code || guest?.parentGuest?.rsvp_code)} target="_blank">
                                        <img
                                          className="action-icon"
                                          width={20}
                                          src={eye}
                                          alt={"rsvp for " + guest?.guest_name}
                                        />
                                      </a>
                                      }
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <h4 className="not-found">No Data Found</h4>
                      )}
                    </TabList>
                  </div>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllergyReport;
